export const search = (state) => state.debtors.search
export const loading = (state) => state.debtors.loading
export const alert = (state) => state.debtors.alert
export const districtsData = (state) => state.debtors.districtsData
export const streetData = (state) => state.debtors.streetData
export const serialNumberData = (state) => state.debtors.serialNumberData
export const displayData = (state) => state.debtors.displayData
export const form = (state) => state.debtors.form
